import { ABI } from './CrowdloanRewardsABI';

export const CROWDLOAN_REWARDS_CONTRACT_ADDRESS =
  '0x0000000000000000000000000000000000000801';

export const CrowdloanRewardsContractABI = ABI;
